import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { ColorsService } from "../../../../services/colors.service";
import { ColorsDataType } from "../../../../interfaces/admin.interface";

interface ColorSelectProps {
  setFieldValue: (field: string, value: any) => void;
  color_id: number | null;
  selectedName: string | undefined;
  setSelectedName: (value: string | undefined) => void;
  field: string;
}

const SelectColor: React.FC<ColorSelectProps> = ({
  setFieldValue,
  color_id,
  selectedName,
  setSelectedName,
  field,
}) => {
  const [colors, setColors] = useState<ColorsDataType[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setLoading(true);
    ColorsService.getAllColors()
      .then((response) => {
        setColors(response?.data?.colors);
        const selectedColor = response?.data?.colors?.find(
          (element: ColorsDataType) => element.id === color_id
        );
        setSelectedName(selectedColor?.name);
      })
      .finally(() => setLoading(false));
  }, [color_id, setSelectedName]);

  return (
    <Select
      style={{ width: "100%", height: "46px" }}
      placeholder={loading ? "Rənglər yüklənir..." : "Rəng seçin"}
      options={colors?.map((element) => ({
        label: element.name,
        value: element.name,
      }))}
      value={selectedName}
      onChange={(newName) => {
        setSelectedName(newName);
        const selectedColor = colors.find(
          (element) => element.name === newName
        );
        if (selectedColor) {
          setFieldValue(field, selectedColor.id);
        }
      }}
    />
  );
};

export default SelectColor;
